/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OAuthResponseDto } from '../../models/o-auth-response-dto';

export interface NaverAuthControllerNaverLogin$Params {

/**
 * 인가 코드
 */
  code: string;
}

export function naverAuthControllerNaverLogin(http: HttpClient, rootUrl: string, params: NaverAuthControllerNaverLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, naverAuthControllerNaverLogin.PATH, 'post');
  if (params) {
    rb.query('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OAuthResponseDto>;
    })
  );
}

naverAuthControllerNaverLogin.PATH = '/api/oauth/naver/signin';
